var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	25517: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	22495: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	86764: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(43160))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ant-design/icons",
	},
	35869: {
		fallback: () => (() => (__webpack_require__(84447))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.13.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "axios",
	},
	74557: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(11924))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.9.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	2752: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898), __webpack_require__.e(495), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(25554))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"250": [
		35869
	],
	"275": [
		2752,
		86764
	],
	"495": [
		22495
	],
	"517": [
		25517
	],
	"557": [
		74557
	],
	"752": [
		2752
	],
	"764": [
		86764
	],
	"869": [
		35869
	],
	"898": [
		25517
	],
	"938": [
		74557
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}